var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_590_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 4.125C2.25 3.06434 2.25 2.53401 2.5795 2.2045C2.90901 1.875 3.43934 1.875 4.5 1.875H5.625C6.68566 1.875 7.21599 1.875 7.5455 2.2045C7.875 2.53401 7.875 3.06434 7.875 4.125V6C7.875 7.06066 7.875 7.59099 7.5455 7.92049C7.21599 8.25 6.68566 8.25 5.625 8.25H4.5C3.43934 8.25 2.90901 8.25 2.5795 7.92049C2.25 7.59099 2.25 7.06066 2.25 6V4.125Z",
    stroke: "#2683ED",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 7.125C1.62868 7.125 1.125 6.62132 1.125 6V3.75C1.125 2.33579 1.125 1.62868 1.56434 1.18934C2.00368 0.75 2.71079 0.75 4.125 0.75H5.625C6.24632 0.75 6.75 1.25368 6.75 1.875",
    stroke: "#2683ED",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_590_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBlue);
export default __webpack_public_path__ + "static/media/copyBlue.95f75bf4208dd43286d5e3858cb11a76.svg";
export { ForwardRef as ReactComponent };